import React from 'react';

const NavigateTo = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.20912 0.0788518L1.2057 0.0788517L1.12073 0.0825946C0.565703 0.138404 0.156803 0.588294 0.156803 1.12775L0.160545 1.21272L0.171166 1.29099C0.259405 1.80576 0.691934 2.17664 1.2057 2.17664L5.67707 2.17644L1.04764 6.80587L0.993395 6.8648C0.637122 7.29559 0.664546 7.90614 1.04764 8.28923L1.09798 8.33642C1.50998 8.6982 2.13776 8.68247 2.531 8.28923L7.16013 3.6601L7.16022 8.13116L7.16397 8.21614C7.21978 8.77116 7.66967 9.18007 8.20912 9.18006C8.78841 9.18006 9.25802 8.71046 9.25802 8.13117L9.25802 1.12775L9.25262 1.02102C9.19846 0.487752 8.74857 0.0788517 8.20912 0.0788518Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export default NavigateTo;
